module.exports = __webpack_public_path__ + "static/media/forklift_idle_sel.e440ce76.svg";